import React, { useState } from 'react';
import { Button, Paper, Typography, Box } from '@material-ui/core';
import AlertDialog from '../../../../../../components/AlertDialog/index.es6';
import { getExtendedRelationships, getNuclearRelationships, getNuclearRelationships2 } from '../../../../PolicyAdmin/helpers';

const SelectRelationshipModal = ({
  show,
  onClose,
  onSelectRelationship,
  memberType,
  currentMembers,
  addedMembers,
  nuclearPlan,
  parentPlan,
  policy
}) => {
  const [selectedRelationship, setSelectedRelationship] = useState(null);

  // Get relationships based on member type
  const getRelationshipsForType = () => {
    if (memberType === 'nuclear') {
      // Nuclear members are only Spouse and Child (Principal already exists, can't add another)
      const allNuclear = getNuclearRelationships(nuclearPlan);
      return allNuclear.filter(rel => {
        const relationship = Object.keys(rel)[0];
        return relationship === 'Spouse' || relationship === 'Child';
      });
    } else if (memberType === 'parent') {
      // Parent members only include Parent and Parent_In_Law
      const allExtended = getExtendedRelationships(parentPlan || nuclearPlan);
      return allExtended.filter(rel => {
        const relationship = Object.keys(rel)[0];
        return relationship === 'Parent' || relationship === 'Parent_In_Law';
      });
    } else if (memberType === 'extended') {
      return getNuclearRelationships2();
    }
    return [];
  };

  const relationships = getRelationshipsForType();

  // Count current + added members by relationship
  const countRelationship = (relationship) => {
    const allMembers = [...currentMembers, ...addedMembers];
    return allMembers.filter(m => m.relationship === relationship).length;
  };

  // Get max count for extended members
  const getExtendedMaxCount = () => {
    const extendedMembers = [...currentMembers, ...addedMembers].filter(
      m => m.type === 'Extended_2' || !['Principal', 'Spouse', 'Child', 'Parent', 'Parent_In_Law'].includes(m.relationship)
    );
    return 12 - extendedMembers.length;
  };

  const handleSelect = (relationship) => {
    setSelectedRelationship(relationship);
  };

  const handleAdd = () => {
    if (selectedRelationship) {
      onSelectRelationship(selectedRelationship);
      setSelectedRelationship(null);
    }
  };

  const handleCancel = () => {
    setSelectedRelationship(null);
    onClose();
  };

  return (
    <AlertDialog
      custom
      show={show}
      onClose={handleCancel}
      size="md"
      showCancel={false}
      showConfirm={false}
      showTitle={false}
      style={{ marginTop: '0', top: '50%', transform: 'translateY(-50%)' }}
    >
      <div style={{ padding: '25px' }}>
        <Typography variant="h5" gutterBottom style={{ marginBottom: '20px', textAlign: 'center' }}>
          {memberType === 'nuclear' && 'Select Nuclear Member Relationship'}
          {memberType === 'parent' && 'Select Parent Member Relationship'}
          {memberType === 'extended' && 'Select Extended Member Relationship'}
        </Typography>

        <div style={{ maxHeight: '350px', overflowY: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {relationships.map((relationshipObj) => {
            const relationship = Object.keys(relationshipObj)[0];
            const maxCount = memberType === 'extended'
              ? getExtendedMaxCount()
              : relationshipObj[relationship];
            const count = countRelationship(relationship);
            const isDisabled = count >= maxCount;

            return (
              <Paper
                key={relationship}
                onClick={!isDisabled ? () => handleSelect(relationship) : null}
                style={{
                  margin: '10px',
                  padding: '18px 24px',
                  cursor: !isDisabled ? 'pointer' : 'not-allowed',
                  backgroundColor: selectedRelationship === relationship ? '#032A37' : '#fff',
                  color: selectedRelationship === relationship ? '#fff' : '#000',
                  width: '450px',
                  opacity: !isDisabled ? '1' : '0.5',
                }}
              >
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h6">{relationship.replace(/_/g, ' ')}</Typography>
                  <Typography variant="h6">{`${count}/${maxCount}`}</Typography>
                </Box>
              </Paper>
            );
          })}
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '20px' }}>
          <Button
            variant="contained"
            onClick={handleCancel}
            style={{ backgroundColor: '#ccc' }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={!selectedRelationship}
            onClick={handleAdd}
            style={{ backgroundColor: !selectedRelationship ? '#ccc' : '#032A37' }}
          >
            Add
          </Button>
        </div>
      </div>
    </AlertDialog>
  );
};

export default SelectRelationshipModal;
